export default __webpack_public_path__ + "static/charts-44fd2e33eb3ef3874ce7ea9104549f3d.jpg";